import AssistantScriptDialog from '@shared/components/AssistantScriptDialog';
import type { IAssistantScriptDialogProps } from '@shared/interfaces/assistantScripts';
import type { PollyLanguage } from '@shared/interfaces/polly';

import { useMytaverse } from '@providers/MytaverseProvider';
import { useAssistant } from '@core/assistant/providers/Provider';
import AssistantQueryServiceService from '@services/AssistantQueryService';
import AssistantScriptsService from '@shared/services/AssistantScriptsService';
import { usePreventGameKeydownListening } from '@hooks';

type Props = Omit<
  IAssistantScriptDialogProps,
  | 'userFirstName'
  | 'onGenerateAudio'
  | 'onTranslate'
  | 'baseLanguage'
  | 'languages'
>;

const AssistantScriptDialogWrapper = (props: Props) => {
  const { userName } = useAssistant();
  const { appSettings } = useMytaverse();
  const paperRef = usePreventGameKeydownListening<HTMLDivElement>();

  const handleGenerateAudio: IAssistantScriptDialogProps['onGenerateAudio'] = (
    params,
  ) =>
    AssistantQueryServiceService.generateAssistantAudio({
      ...params,
      disableOptimizations: true,
    });

  const handleTranslate: IAssistantScriptDialogProps['onTranslate'] = async (
    langs,
    texts,
  ) => {
    const result = await AssistantScriptsService.translateScript({
      languages: langs as unknown as PollyLanguage[],
      texts,
    });
    return result.translations as unknown as Partial<
      Record<PollyLanguage, string[]>
    >;
  };

  return (
    <AssistantScriptDialog
      {...props}
      baseLanguage={appSettings?.aiAssistant?.baseLanguage}
      languages={appSettings?.aiAssistant?.languages}
      paperRef={paperRef}
      modalTheme="light"
      userFirstName={userName}
      onGenerateAudio={handleGenerateAudio}
      onTranslate={handleTranslate}
    />
  );
};

export default AssistantScriptDialogWrapper;
